module.exports = __webpack_public_path__ + "static/media/cables.27eb794f.png";